import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { fetchDonationObject, fetchGeneralObject } from "../Redux/slices/otherSlice";
import { fetchHomeObject } from "../Redux/slices/homeSlice";

const UploadContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  padding: 30px;
  border-radius: 15px;
  background: #ffffff;
  border: 1px solid #1b2a501a;
  width: 420px;

  h3 {
    color: #1b2a50;
    font-size: 18px;
    font-weight: 600;
  }
  @media (max-width: 500px) {
    width: 320px;
    h3 {
      font-size: 16px;
    }
  }
  @media (max-width: 360px) {
    width: 270px;

  } 
`;

const DropZone = styled.div`
  width: 357px;
  height: 160px;
  border: 1px solid #1b2a501a;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  background: #f7f7f7;
  cursor: pointer;
  transition: border-color 0.3s;

  &:hover {
    border-color: #0056b3;
  }
  @media (max-width: 500px) {
    width: 257px;

  }
  @media (max-width: 360px) {
    width: 200px;

  } 
`;

const UploadIcon = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #5a5a5a;

  svg {
    width: 40px;
    height: 40px;
    fill: #0056b3;
  }
`;

const UploadButton = styled.button`
  width: 357px;
  height: 48px;
  font-size: 18px;
  font-weight: 600;
  color: white;
  background: #2d81eb;
  border: none;
  border-radius: 7px;
  border: 1px solid #2d81eb;
  cursor: pointer;
  transition: background 0.3s;

  &:hover {
    background: #0056b3;
  }
  @media (max-width: 500px) {
    width: 257px;

  }
  @media (max-width: 360px) {
    width: 200px;

  } 
`;

const FileName = styled.p`
  font-size: 14px;
  color: #333;
`;

const FooterRap = styled.div`
  .footer {
    background: #f7f2ed;
  }
  .left-upper-footer h2 {
    color: #1b2a50;
    font-size: 50px;
    font-weight: 700;
    line-height: 50px;
    max-width: 480px;
  }
  .left-upper-footer p {
    color: #565e6f;
    font-size: 18px;
    font-weight: 400;
    line-height: 24px;
    max-width: 377px;
  }
  .button {
    color: #1b2a50;
    font-size: 16px;
    font-weight: 600;
    border: 1px solid #1b2a50;
    border-radius: 7px;
    width: 177px;
    height: 45px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    text-decoration: none;
    background: transparent;
  }
  .left-upper-footer {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .upper-footer {
    padding: 50px 205px;
    display: flex;
    align-items: center;
    gap: 20px;
    justify-content: space-between;
  }
  .footer-down p {
    color: #ffffffb2;
    font-size: 18px;
    font-weight: 400;
    line-height: 24px;
    max-width: 271px;
  }
  .footer-1 h4 {
    color: #ffffff;
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 30px;
  }
  .footer-link {
    color: #ffffff80;
    font-size: 18px;
    font-weight: 400;
  }
  .footer-1 {
    display: flex;
    flex-direction: column;
    gap: 15px;
  }
  .footer-2 {
    display: flex;
    gap: 15px;
  }
  .icon-div {
    border: 1px solid #ffffff80;
    width: 38px;
    height: 38px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .footer-down {
    display: flex;
    justify-content: space-between;
    gap: 30px;
    padding: 50px;
    padding-top: 100px;
  }
  .down-footer p {
    color: #ffffff80;
    font-size: 14px;
    font-weight: 400;
  }
  .down-footer {
    display: flex;
    justify-content: space-between;
    gap: 20px;
    align-items: center;
    padding: 50px;
    padding-right: 100px;
  }
  .all-down-footer {
    background: #1b2a50;
    border-top-right-radius: 200px;
  }
  .donation h2 {
    color: #1B2A50;
    font-size: 50px;
    font-weight: 700;
  }
  .donation p {
    color: #565E6F;
    font-size: 18px;
    font-weight: 400;
    max-width: 576px;
    line-height: 24px;

  }
  .donation button {
    color: #ffffff;
    font-size: 18px;
    font-weight: 600;
    background: #2D81EB;
    border: 1px solid #2D81EB;
    padding: 10px;
  }
  .donation {
    background: #F7F2ED;
    padding-top: 100px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    justify-content: center;
    align-items: center;
    border-radius: 7px;
    padding-bottom: 100px;
  }

  @media (max-width: 1200px) {
.upper-footer {
    padding: 50px 100px;
}
  }
  @media (max-width: 1024px) {
.upper-footer {
    padding: 50px;
}
  }
  @media (max-width: 992px) {
.footer-down {
    flex-wrap: wrap;
}
  }
  @media (max-width: 800px) {
    .upper-footer {
        flex-wrap: wrap;
    }
    .down-footer {
        flex-wrap: wrap;
    }
  }
  @media (max-width: 500px) {
    .upper-footer {
    padding: 20px;
}
.left-upper-footer h2 {
  text-align: center;
  font-size: 39px;
}
.left-upper-footer {
    flex-direction: column;
    align-items: center;
  }
  }
  
`;

const Footer = () => {
  const socialIcons = {
    facebook: "line-md:facebook",
    twitter: "mingcute:twitter-fill",
    instagram: "mdi:instagram",
    linkedin: "ri:linkedin-fill",
  };
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const location = useLocation();
  const [file, setFile] = useState(null);
  const { general,  error } = useSelector((state) => state.others);
  const { homeObject, loading} = useSelector((state) => state.home);
      const { donation } = useSelector((state) => state.others);

  
  const handleFileUpload = (event) => {
    const uploadedFile = event.target.files[0];
    if (uploadedFile) {
      setFile(uploadedFile);
    }
  };

  const siteDescription = general?.data?.websetting?.site_description
  const socialLinks = general?.data?.socialLinks
  const callToAction = homeObject?.data?.calltoaction  
  const slider = homeObject?.data?.slider

  const lastSection = donation?.data?.lastSection

  console.log(lastSection);
 useEffect(() => {
              dispatch(fetchDonationObject()); 
            }, [dispatch]);

const handleMoveToSigin = () => {
  navigate ("/signin")
}




   useEffect(() => {
          dispatch(fetchGeneralObject()); // Call API on component mount
        }, [dispatch]);
        
          useEffect(() => {
            dispatch(fetchHomeObject()); // Call API on component mount
          }, [dispatch]);
      const handleJoinTheMove = () => {
        window.location.href = lastSection?.first_btn_link
      }
  return (
    <FooterRap>
      <div className="footer">
      {location.pathname === "/donation" ? (
        <div className="donation containers">
          <h2>{lastSection?.title}</h2>
          <p>{lastSection?.content}</p>
          <button onClick={handleJoinTheMove}>{lastSection?.first_btn_title}</button>
        </div> 
      ) : (
        <div className="upper-footer">
          <div className="left-upper-footer">
            <h2>{callToAction?.title}</h2>
            <div className="home-3-middle-left" dangerouslySetInnerHTML={{ __html: callToAction?.content }} />

            <Link className="button" to={`${slider?.second_btn_link}`}>{slider?.second_btn_title}</Link>
          </div>
          <UploadContainer>
            <h3>Submit your resource here</h3>
            <DropZone>
              <label htmlFor="file-upload">
                <UploadIcon>
                  <img src="/images/img-1.png" alt="" />
                </UploadIcon>
              </label>
              {/* <input
                id="file-upload"
                type="file"
                style={{ display: "none" }}
                onChange={handleFileUpload}
              /> */}
            </DropZone>
            <UploadButton onClick={handleMoveToSigin}>Upload document</UploadButton>
            {file && <FileName>{file.name}</FileName>}
          </UploadContainer>
        </div>
      )}
        <div className="all-down-footer">
          <div className="footer-down">
            <p>
            {siteDescription}
            </p>
            <div className="footer-1">
              <h4>QUICK LINKS</h4>
              <Link to="/framework" className="footer-link"  onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>Framework</Link>
              <Link to="/advanceSearch" className="footer-link">Explore</Link>
              <Link to="/about" className="footer-link">About Us</Link>
              <Link to="/contact" className="footer-link">Contact Us</Link>
            </div>
            <div className="footer-1">
              <h4>USEFUL LINKS</h4>
              <Link to="/signin" className="footer-link">Collaborators</Link>
              <Link to="/result" className="footer-link">Resources</Link>
              <Link to="/faq" className="footer-link">FAQ</Link>
             
            </div>
            <div className="footer-1">
              <h4>SOCIALS</h4>
              <div className="footer-2">
               

                          {socialLinks?.map((social) => (
                <div className="icon-div">
                        <Link
                          key={social?.id}
                          to={social?.social_url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="socials"
                        >
                          <Icon
                            width="16px"
                            height="16px"
                            icon={socialIcons[social.social_name.toLowerCase()]}
                            style={{ color: "#565E6F" }}
                          />
                        </Link>
                        </div>
                      ))}
               
              </div>
            </div>
          </div>
          <div className="down-footer">
            <p>© 2025 RECD, All Rights Reserved</p>
            <p>Privacy & Cookie Policy</p>
          </div>
        </div>
      </div>
    </FooterRap>
  );
};
export default Footer;
